import { render } from "./NavBarComponent.vue?vue&type=template&id=493f53bd&scoped=true"
import script from "./NavBarComponent.vue?vue&type=script&lang=js"
export * from "./NavBarComponent.vue?vue&type=script&lang=js"

import "./NavBarComponent.vue?vue&type=style&index=0&id=493f53bd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-493f53bd"]])

export default __exports__